module.exports = __webpack_public_path__ + "static/media/logo-nodejs.5d51536d.svg";